import { Error as ErrorIcon } from '@mui/icons-material';
import { Alert, styled, Typography } from '@mui/material';
import { useStore } from 'common/store';
import ActionButtons from './ActionButtons';
import { DecisionAlertProps } from './DecisionAlert.props';
import UseDecisionAlertStyles from './DecisionAlert.styles';

const PREFIX = 'DecisionAlert';

const classes = {
  alertStyle: `${PREFIX}-alertStyle`,
  yesButton: `${PREFIX}-yesButton`,
  noButton: `${PREFIX}-noButton`,
};

const StyledAlert = styled(Alert)(({ theme }) => ({
  [`&.${classes.alertStyle}`]: {
    color: theme.palette.warning.main,
    fontSize: '1rem',
    padding: '1rem',
    border: `2px solid ${theme.palette.warning.main}`,
    marginBottom: '1rem',
  },

  [`& .${classes.yesButton}`]: {
    '&.MuiButton-containedSizeLarge': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.white,
      marginRight: '1rem',
    },
  },

  [`& .${classes.noButton}`]: {
    '&.MuiButton-sizeLarge': {
      color: theme.palette.warning.main,
      marginRight: '1rem',
      '&:hover': {
        backgroundColor: theme.palette.warning.veryLight,
      },
    },
  },
}));

const DecisionAlert = ({
  cause,
  updateDecisionService,
  setShowDisconnectDialog,
  setDecisionData,
}: DecisionAlertProps) => {
  const { causing_object_name } = cause;
  const classes = UseDecisionAlertStyles();
  const [{ firmId, user }] = useStore();

  const decisionUpdate = (trueOrFalse: boolean) => ({
    ...cause,
    resolved_by: user.id,
    keep_updated: trueOrFalse,
  });

  const handleNo = () => {
    setShowDisconnectDialog(true);
    const baseData = decisionUpdate(false);
    setDecisionData({ decisions: [baseData], firm: firmId });
  };

  const handleYes = () => {
    const baseData = decisionUpdate(true);
    const decisionData = { decisions: [baseData], firm: firmId };
    updateDecisionService(firmId, decisionData);
  };

  return (
    <StyledAlert
      icon={<ErrorIcon fontSize="medium" style={{ alignSelf: 'center' }} />}
      severity="warning"
      variant="outlined"
      className={classes.alertStyle}
      action={<ActionButtons classes={classes} handleYes={handleYes} handleNo={handleNo} />}>
      <Typography>
        Scalar has updated the <b>{causing_object_name}</b> comp group. There is at least one non-final valuation that
        uses that comp group. <b>Would you like to automatically update valuations based on the comp group?</b>
      </Typography>
    </StyledAlert>
  );
};

export default DecisionAlert;
